<template>
  <v-container>
    <PageHeader :title="name" />

    <v-form ref="form" style="width: 100%">
      <v-card>
        <Subheader title="Tenant and Project Names" no-search></Subheader>
        <v-progress-linear v-if="isLoading" :indeterminate="true"></v-progress-linear>
        <v-card-text>
          <v-layout row wrap v-if="!isLoading">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 md6 offset-md2 pl-1 pr-1>
                  <v-text-field label="Tenant Name" required v-model="tenantNameForm"></v-text-field>
                </v-flex>
                <v-flex xs12 md6 offset-md2 pl-1 pr-1>
                  <v-text-field label="Project Name" required v-model="projectNameForm"></v-text-field>
                </v-flex>
                <v-flex xs12 md4 offset-md4 pl-1 pr-1>
                  <v-btn color="success" block @click="handleSave">
                    <v-icon class="mr-1">done</v-icon>
                    {{ $t('Button.Save') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-form>

    <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
      {{ snackMessage }}
      <v-btn dark flat @click.native.stop.prevent="snackbar = false">{{ $t('Button.Close') }}</v-btn>
    </v-snackbar>

    <ErrorDialog v-model="errorDialog.show" :data="errorDialog.data" :title="errorDialog.title"></ErrorDialog>
  </v-container>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import {
    UiConfigKeys,
  } from '@/store/UI/uiconfig'
  import SnackBarUtil from '@/components/mixins/SnackBarUtil'
  import ErrorDialog from '@/components/generic/ErrorDialog'

  const uiConfig = createNamespacedHelpers('uiconfig')

  export default {
    components: {
      ErrorDialog,
    },
    mixins: [SnackBarUtil],
    props: {
      name: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        isLoading: false,
        tenantUiConfigOptions: [],
        tenantNameForm: '',
        projectNameForm: '',
      }
    },
    computed: {
      ...uiConfig.mapGetters(['uiConfigOptions']),
      tenantName() {
        //let that = this
        let tenantNameOption = this.tenantUiConfigOptions.find(
          opt => opt.Key === UiConfigKeys.FileExportTenantName
        )
        if (!tenantNameOption || !tenantNameOption.Value) {
          return this.name
        }
        return tenantNameOption.Value
      },
      projectName() {
        //let that = this
        let projectNameOption = this.tenantUiConfigOptions.find(
          opt => opt.Key === UiConfigKeys.FileExportProjectName
        )
        if (!projectNameOption || !projectNameOption.Value) {
          return this.name
        }
        return projectNameOption.Value
      },
      errorDialog() {
        return this.$store.getters['app/errorDialog']
      },
    },
    watch: {
      tenantName() {
        this.tenantNameForm = this.tenantName
      },
      projectName() {
        this.projectNameForm = this.projectName
      },
    },
    mounted() {
      this.fetchUiConfigOptions()
    },
    methods: {
      ...uiConfig.mapActions([
        'getUiConfigOptions',
        'putUiConfigOptionArray',
      ]),
      initForm() {
        this.tenantNameForm = this.tenantName
        this.projectNameForm = this.projectName
      },
      handleSave() {
        let data = [{
          Key: UiConfigKeys.FileExportTenantName,
          Value: this.tenantNameForm,
        },
        {
          Key: UiConfigKeys.FileExportProjectName,
          Value: this.projectNameForm,
        },
        ]
        this.putUiConfigOptions(data)
      },
      fetchUiConfigOptions() {
        let that = this
        let options = {
          config: {
            params: {
              tenant: that.name,
            },
          },
          successCb(data) {
            that.initForm()
            that.tenantUiConfigOptions = data
            that.isLoading = false
          },
          failedCb: (msg) => {
            console.error(msg)
            that.isLoading = false
            this.$store.dispatch('app/setErrorDialog', {
              data: `Failed to fetch options: ${msg}`,
              title: '',
              show: true,
            })
          },
        }
        this.isLoading = true
        this.getUiConfigOptions(options)
      },
      putUiConfigOptions(configOptions) {
        let that = this
        let options = {
          data: configOptions,
          config: {
            params: {
              tenant: that.name,
            },
          },
          successCb() {
            that.isLoading = false
            that.handleNotification({
              type: 'success',
              message: 'Successfully updated configurations',
            })
          },
          failedCb: (msg) => {
            console.error(msg)
            that.isLoading = false
            this.$store.dispatch('app/setErrorDialog', {
              data: `Failed to update configurations: ${msg}`,
              title: '',
              show: true,
            })
          },
        }
        this.isLoading = true
        this.putUiConfigOptionArray(options)
      },
    },
  }
</script>

<style scoped lang="stylus"></style>